import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import {
  Box,
  Stack,
  Typography
} from '@mui/material';


export const FormStepper = ({ steps, activeStep = 1, isMobile }) => {
  const stepWidth = isMobile ? 90 : 180;
  const connectorWidth = isMobile ? 32 : 64;
  const stepSpacing = isMobile ? 2 : 8;

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      sx={{ width: '100%' }}
    >
      <Stack
        direction="row"
        spacing={stepSpacing}
        alignItems="flex-start"
      >
        {steps.map((step, index) => {
          const completed = index + 1 < activeStep;
          const active = index + 1 === activeStep;

          return (
            <Box
              key={step.label}
              sx={{
                position: 'relative',
                textAlign: 'center',
                minWidth: stepWidth
              }}
            >
              {/* Linia */}
              {index < steps.length - 1 && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 14,
                    left: '50%',
                    width: `calc(100% + ${connectorWidth}px)`,
                    height: 1.5,
                    bgcolor:
                    index < activeStep
                      ? '#081A9E'
                      : '#D1D5DB',
                    zIndex: 0
                  }}
                />
              )}

              <Stack
                alignItems="center"
                spacing={1}
                sx={{
                  position: 'relative',
                  zIndex: 1
                }}
              >
                <Box
                  sx={{
                    width: isMobile ? 22 : 28,
                    height: isMobile ? 22 : 28,
                    borderRadius: isMobile ? '4px' : '6px',
                    fontSize: isMobile ? 13 : 16,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,

                    ...(completed && {
                      bgcolor: '#081A9E',
                      color: '#fff'
                    }),

                    ...(active && {
                      bgcolor: '#081A9E',
                      color: '#fff'
                    }),

                    ...(!active &&
                    !completed && {
                      bgcolor: '#fff',
                      color: '#081A9E',
                      border: '1.5px solid #081A9E'
                    })
                  }}
                >
                  {completed
                    ? <CheckIcon sx={{ fontSize: 18 }} />
                    : index + 1}
                </Box>

                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                >
                  {!isMobile && index + 1 < activeStep && <ModeEditIcon />}

                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#111827'
                    }}
                  >
                    {step.label}
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          );
        })}
      </Stack>
    </Stack>
  );
};
